import { createRoot } from "react-dom/client";

// style.scss
import "assets/style.css";

// scroll bar
import "simplebar-react/dist/simplebar.min.css";

// apex-chart
import "assets/third-party/apex-chart.css";
import "assets/third-party/react-table.css";

import "@fontsource/public-sans/400.css";
import "@fontsource/public-sans/500.css";
import "@fontsource/public-sans/600.css";
import "@fontsource/public-sans/700.css";

// project imports
import App from "./App";
import { ConfigProvider } from "contexts/ConfigContext";
import { AuthProvider } from "contexts/AuthContext";
import reportWebVitals from "./reportWebVitals";

import { IntlProvider } from "use-intl";
import en from "../messages/en.json";
import sr from "../messages/sr.json";

const messagesMap = {
  en,
  sr,
};

//ovde će se pokupiti user.language

const language = "en";
const messages = messagesMap[language];

//const messages = sr;

const container = document.getElementById("root");
const root = createRoot(container);

// ==============================|| MAIN - REACT DOM RENDER ||============================== //

root.render(
  <ConfigProvider>
    <AuthProvider>
      <IntlProvider locale={language} messages={messages}>
        <App />
      </IntlProvider>
    </AuthProvider>
  </ConfigProvider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
